module.exports = __webpack_public_path__ + "img/added-service-unit-06.c8f61759.png";